import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { NotificationItem } from '../../models/Notifications';

interface INotificationService {
  getNotifications: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<NotificationItem[]>>;
  markAllAsRead: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  markAsRead: (
    notificationId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  deleteNotification: (
    notificationId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
}

export const notificationService: INotificationService = {
  getNotifications(queryString, axiosConfig) {
    return ajax.get<NotificationItem[]>(
      `${config.benefitApiUrl}/odata/notifications?${queryString}`,
      axiosConfig,
    );
  },
  markAllAsRead(axiosConfig) {
    return ajax.put<boolean>(
      `${config.benefitApiUrl}/notifications/mark-all-as-read`,
      axiosConfig,
    );
  },
  markAsRead(notificationId, axiosConfig) {
    return ajax.put<boolean>(
      `${config.benefitApiUrl}/notifications/mark-as-read/${notificationId}`,
      axiosConfig,
    );
  },
  deleteNotification(notificationId, axiosConfig) {
    return ajax.delete<boolean>(
      `${config.benefitApiUrl}/notifications/${notificationId}`,
      axiosConfig,
    );
  },
};
